import { render, staticRenderFns } from "./progress.vue?vue&type=template&id=a96c527a"
import script from "./progress.vue?vue&type=script&lang=js"
export * from "./progress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports